import React, { FC } from 'react';
import TopicList from './topic-list';

interface Props {
    className?: string;
}

const ItemContentTabTwo: FC<Props> = ({ children, className }) => {

    return <div className="flex flex-row flex-grow overflow-hidden my-4">
        <TopicList />
        <div className={`flex flex-column flex-grow ml-4 ${className ? className : ''}`}>{children}</div>
    </div>;
};

export default ItemContentTabTwo;

